<template>
  <div class="user" v-if="this.$store.state.studentInfoShow">
    <div class="user-content">
      <div class="user-avatar">
        <img :src="avatar" />
      </div>
      <a-icon @click="cancel" class="close-icon" type="close" />
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" class="user-form">
        <a-form-item label="姓名">
          <a-input
            :maxLength="30"
            @keydown.native="keydown($event)"
            allowClear
            autocomplete="off"
            placeholder="请输入姓名"
            v-decorator="[
                'studentName',
                studentRules.name,
              ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="学校">
          <a-select
            :filter-option="filterOption"
            :not-found-content="null"
            :show-arrow="false"
            @blur="handleBlur"
            @change="handleChange"
            @focus="handleFocus"
            @keydown.native="keydown($event)"
            @search="handleSearch"
            allowClear
            option-filter-prop="children"
            placeholder="请选择学校"
            show-search
            v-decorator="[
                'school',
                studentRules.school,
              ]"
          >
            <a-select-option
              :key="index"
              :value="item.schoolId"
              v-for="(item,index) in school"
            >{{item.schoolName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="学号">
          <a-input
            :maxLength="30"
            @keydown.native="keydown($event)"
            allowClear
            autocomplete="off"
            placeholder="请输入学号"
            v-decorator="[
                'studentNumber',
                studentRules.studentNumber,
              ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="手机号">
          <a-input
            :maxLength="11"
            @keydown.native="keydown($event)"
            allowClear
            autocomplete="off"
            placeholder="请输入手机号"
            v-decorator="[
                'phone',
                studentRules.phone,
              ]"
          ></a-input>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }" align="right" class="btn-con">
          <a-button @click="cancel" class="cancel-btn">取消</a-button>
          <a-button @click="confirm" type="primary">确定</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import global from '../../utils/Global.vue'
export default {
  data () {
    return {
      form: this.$form.createForm(this),
      studentRules: {
        name: {
          rules: [
            //rules是验证规则，
            { required: true, message: '姓名不能为空！' },
            {
              validator: this.checkName, //自定义的校验函数
            },
          ],
        },
        school: {
          rules: [
            //rules是验证规则，
            { required: true, message: '学校不能为空！' },
            {
              validator: this.checkName, //自定义的校验函数
            },
          ],
        },
        studentNumber: {
          rules: [
            //rules是验证规则，
            { required: true, message: '学号不能为空！' },
            {
              validator: this.checkName, //自定义的校验函数
            },
          ],
        },
        phone: {
          rules: [
            //rules是验证规则，
            { required: true, message: '手机不能为空！' },
            {
              pattern: /^1[2-9]{1}[0-9]{9}$/,
              message: '请输入正确的手机号！',
            },
            {
              validator: this.checkName, //自定义的校验函数
            },
          ],
        },
      },
      avatar: global.userInfo ? global.userInfo.img_url : null,
      school: []
    }
  },
  computed: {
    studentData () {
      return this.$store.state.studentInfo
    },
    studentInfo () {
      let school = []
      let studentData = this.$store.state.studentInfo
      studentData.forEach(item => {
        school.push({
          schoolId: item.school_id,
          schoolName: item.name
        })
      });
      return {
        name: this.studentData[0].name,
        school,
      }
    },
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  methods: {
    // 禁止输入空格
    keydown (e) {
      if (e.keyCode == 32) {
        e.returnValue = false
      }
    },
    handleChange (value) {
    },
    handleBlur () {
      this.school = []
    },
    handleFocus () {
    },
    handleSearch (value) {
      this.school = value == '' ? [] : this.studentInfo.school
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    cancel () {
      this.$store.commit('changeStuInfoShow', false)
    },
    confirm (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err)
        }
        if (!err) {
          let data = {
            school_id: values.school,
            name: values.studentName,
            student_number: values.studentNumber,
            contact: values.phone,
          }
          this.changeStudentInfo(data)
        }
      })
    },
    changeStudentInfo (data) {
      this.axios(global.ajaxAdd.upInfo, data)
        .then((d) => {
          this.$message.success('修改手机号成功！')
          this.$store.commit('changeStuInfoShow', false)
          location.reload()
        })
        .catch((e) => {
          this.$message.error(e.data.errmsg)
        });
    },
    axios (url, data) {
      var pubData_ = {
        from: "student",
        qid: global.userInfo.qid,
        reg_time: new Date().getTime(),
      };
      if (this.student_id) {
        pubData_.student_id = this.student_id;
      }
      data = Object.assign(pubData_, data);
      var that = this;
      return new Promise(function (resolve, reject) {
        that.$axios
          .post("/api" + url, data, {
            transformRequest: [
              function (data) {
                let params = "";
                for (let index in data) {
                  params += index + "=" + data[index] + "&";
                }
                return params;
              },
            ],
          })
          .then(function (res) {
            if (res && res.data && res.data.errno == 0) {
              if (resolve) {
                resolve(res.data);
              }
            } else if (res && res.data) {
              reject(res);
              switch (res.data.errno) {
                case 400027:
                  break;
                case 39:
                case 700006:
                case 442:
                  //登录信息过期
                  clearTimeout(lessTimer);
                  global.isJumpingToLogin = null;
                  global.userInfo = null;
                  window.location.reload();
                  break;
                case 1000001:
                  break;
              }
            }
          })
          .catch(function (e) {
            reject(e);
            // that.msg(e.errmsg, "error");
          });
      });
    },
  },
}
</script>

<style scoped>
.user {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.6);
}
.user-content {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  width: 400px;
  margin: 0 auto;
  padding: 40px;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 3px;
}
.user-avatar {
  height: 80px;
  width: 80px;
  margin: 0 auto 40px;
  border: 1px solid #eee;
  border-radius: 50%;
  box-shadow: 0 0 10px #ddd;
  background-color: #fff;
}
.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #eee;
}
.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 18px;
  color: #999;
}
.close-icon:hover {
  color: #666;
}
.btn-con {
  margin-bottom: 0;
}
.cancel-btn {
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/main/users.vue